module.exports = __webpack_public_path__ + "img/ava.cb4a6af0.png";